import { render, staticRenderFns } from "./addWarehouse.vue?vue&type=template&id=71098057&scoped=true"
import script from "./addWarehouse.vue?vue&type=script&lang=js"
export * from "./addWarehouse.vue?vue&type=script&lang=js"
import style0 from "./addWarehouse.vue?vue&type=style&index=0&id=71098057&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71098057",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71098057')) {
      api.createRecord('71098057', component.options)
    } else {
      api.reload('71098057', component.options)
    }
    module.hot.accept("./addWarehouse.vue?vue&type=template&id=71098057&scoped=true", function () {
      api.rerender('71098057', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/ratio/addWarehouse.vue"
export default component.exports